import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, Button, Dialog, DialogContent, DialogFooter, DialogHeader, IconButton, Typography, } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { FieldArray, useField } from 'formik';
import { Range } from './Range';
export function Ranges(props) {
    const { name, onClose } = props;
    const [field] = useField(`${name}.ranges`);
    // TODO: Give possibility to add preset data like `Upcoming 30/60/90 days`
    const defaultRangeData = {
        fromNow: true,
        fromOffset: { value: 0, timeUnit: 'day', roundingTimeUnit: 'day' },
        toNow: true,
        toOffset: { value: 31, timeUnit: 'day', roundingTimeUnit: 'day' },
    };
    return (<FieldArray name={`${name}.ranges`}>
      {({ push, remove }) => (<Dialog onClose={onClose}>
          <DialogHeader title={t({ message: 'Date ranges', comment: 'Insights: Date range configuration dialog title' })} subtitle={t({
                message: 'Configure date ranges for the widget',
                comment: 'Insights: Date range configuration dialog description',
            })} action={<Button type="button" appearance="secondary" size="small" onClick={() => push(defaultRangeData)}>
                Add range
              </Button>}/>
          <DialogContent>
            <Box p="lg" flexDirection="column" gap="lg">
              {Boolean(field.value.length) && (<Box gap="lg" flexDirection="column">
                  {field.value.map((_, index) => (<Box 
                // eslint-disable-next-line react/no-array-index-key
                key={index} flexDirection="column" gap="lg" bg="semantic.surface.secondary" p="lg" borderRadius="md" width="100%">
                      <Box alignItems="center" justifyContent="space-between">
                        <Typography $fontWeight="semibold">
                          <Trans comment="Insights widget form: Label for range">Range</Trans> {index + 1}
                        </Typography>
                        <IconButton type="button" aria-label={t({ message: 'Remove range', comment: 'Insights widget form: Remove range' })} $round size="xs" appearance="secondary" onClick={() => remove(index)}>
                          <Falcon icon="trash-can"/>
                        </IconButton>
                      </Box>
                      <Range name={`${name}.ranges[${index}]`}/>
                    </Box>))}
                </Box>)}
            </Box>
          </DialogContent>
          <DialogFooter>
            <Button type="button" size="small" appearance="primary" onClick={onClose}>
              <Trans comment="Insights: Date range configuration dialog done button">Done</Trans>
            </Button>
          </DialogFooter>
        </Dialog>)}
    </FieldArray>);
}
